import { Platform } from '@/utils/platform';
import { newInvoke } from '../../QTBridge';
import { call } from '@popo-bridge/web';

/**
 * 前端页面准备好之后，通知客户端
 */
export const loadEnd = async () => {
  if (Platform.isPOPO) {
    if (Platform.isPC) {
      return await newInvoke({
        methodName: 'loadEnd',
        params: {},
      });
    } else {
      return await call('loadEnd', {});
    }
  }
};
